import React, { ComponentPropsWithoutRef } from "react";
import { containerStyle, overlayContentStyle, overlayStyle } from "./EmptyStateOverlay.css";
import clsx from "clsx";

type EmptyStateOverlayProps = ComponentPropsWithoutRef<"div"> & {
  showOverlay?: boolean;
  overlayComponent: React.ReactNode;
  overlayContentClassName?: string;
};

export const EmptyStateOverlay = ({
  showOverlay = false,
  overlayComponent,
  className,
  overlayContentClassName,
  children,
  ...rest
}: EmptyStateOverlayProps) => {
  return (
    <div {...rest} className={clsx(containerStyle, className)}>
      {children}
      {showOverlay && <div className={overlayStyle} />}
      {showOverlay && (
        <div className={clsx(overlayContentStyle, overlayContentClassName)}>{overlayComponent}</div>
      )}
    </div>
  );
};
